module.exports = __webpack_public_path__ + "img/Carte_Confituur_mobile_social_media_facebook.25b72d98.png";